// extracted by mini-css-extract-plugin
export var divider = "_m3-0";
export var labelWrapper = "_m3-2";
export var lineSvg = "_m3-1";